/* ===========================================================
   Merchloop Essential Store - Quick add dialog
   Own file so ml-essential.js stays under the inline push ceiling.
   Loaded after ml-essential.js, which exposes optionsOf, summaryFor and
   addToCart on window.MLEss. Adds window.MLEss.openQuickAdd.
   All product data comes from window.MLEssential, no network round trip.
   =========================================================== */
(function () {
  'use strict';

  var E = window.MLEss;
  if (!E) return;
  var optionsOf = E.optionsOf;
  var summaryFor = E.summaryFor;
  var addToCart = E.addToCart;

  var QA = null;

  /* Card and swatch images come down at card size. The dialog shows the image
     large, so ask the CDN for a bigger rendition of the same file. */
  function bigger(url) {
    if (!url) return '';
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1900') : url;
  }

  /* The stage takes its color from the shirt. Sample the picture on a tiny
     canvas, ignore anything close to the backdrop color, average the rest and
     keep its hue and saturation. Needs CORS on the image; if the canvas is
     tainted or the load fails the stage simply stays neutral. */
  var tints = {};
  function tintFor(src, cb) {
    if (!src) { cb(null); return; }
    if (Object.prototype.hasOwnProperty.call(tints, src)) { cb(tints[src]); return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var out = null;
      try {
        var N = 48;
        var c = document.createElement('canvas');
        c.width = c.height = N;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(im, 0, 0, N, N);
        var px = x.getImageData(0, 0, N, N).data;
        var bg = [0, 0, 0], n = 0, i, j, k;
        for (j = 0; j < 4; j++) for (i = 0; i < 4; i++) {
          [[i, j], [N - 1 - i, j], [i, N - 1 - j], [N - 1 - i, N - 1 - j]].forEach(function (q) {
            var o = (q[1] * N + q[0]) * 4;
            bg[0] += px[o]; bg[1] += px[o + 1]; bg[2] += px[o + 2]; n++;
          });
        }
        bg = bg.map(function (v) { return v / n; });
        var sum = [0, 0, 0], cnt = 0;
        for (j = 10; j < N - 10; j++) for (i = 10; i < N - 10; i++) {
          k = (j * N + i) * 4;
          var dr = px[k] - bg[0], dg = px[k + 1] - bg[1], db = px[k + 2] - bg[2];
          if (Math.sqrt(dr * dr + dg * dg + db * db) > 42) {
            sum[0] += px[k]; sum[1] += px[k + 1]; sum[2] += px[k + 2]; cnt++;
          }
        }
        if (cnt > 40) {
          var col = sum.map(function (v) { return v / cnt; });
          /* Keep only the hue and saturation of the shirt and rebuild the stage at a
             fixed light value. A navy shirt is dark, so washing its own color toward
             white just gives grey; this gives a soft blue instead. Truly neutral
             shirts (black, white, grey) stay neutral. */
          var r = col[0] / 255, g = col[1] / 255, b = col[2] / 255;
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b), dl = mx - mn, hue = 0, sat = 0;
          var lg = (mx + mn) / 2;
          if (dl > 0.001) {
            sat = dl / (1 - Math.abs(2 * lg - 1));
            if (mx === r) hue = ((g - b) / dl) % 6;
            else if (mx === g) hue = (b - r) / dl + 2;
            else hue = (r - g) / dl + 4;
            hue = Math.round(hue * 60);
            if (hue < 0) hue += 360;
          }
          var neutral = sat < 0.1;
          var s1 = neutral ? 6 : Math.round(Math.max(42, Math.min(78, sat * 100 * 1.15)));
          out = {
            bg: 'hsl(' + hue + ',' + s1 + '%,' + (neutral ? 92 : 87) + '%)',
            mark: 'hsla(' + hue + ',' + Math.min(90, s1 + 10) + '%,' + (neutral ? 40 : 34) + '%,.2)'
          };
        }
      } catch (err) { out = null; }
      tints[src] = out;
      cb(out);
    };
    im.onerror = function () { tints[src] = null; cb(null); };
    im.src = src;
  }

  function ensureDialog() {
    if (QA) return QA;
    var d = document.createElement('dialog');
    d.className = 'ml-qa';
    d.innerHTML =
      '<button type="button" class="ml-qa__close" aria-label="Close">&times;</button>' +
      '<div class="ml-qa__grid">' +
        '<div class="ml-qa__media">' +
          '<div class="ml-qa__stage">' +
            '<span class="ml-qa__mark" aria-hidden="true"></span>' +
            '<span class="ml-qa__count" aria-hidden="true"></span>' +
            '<img class="ml-qa__img" alt="">' +
            '<div class="ml-qa__thumbs" role="group" aria-label="Colors"></div>' +
          '</div>' +
        '</div>' +
        '<div class="ml-qa__info">' +
          '<div class="ml-qa__meta">' +
            '<span class="ml-qa__kick">Quick add</span>' +
            '<span class="ml-qa__title"></span>' +
            '<span class="ml-qa__price"></span>' +
            '<span class="ml-qa__facts"></span>' +
          '</div>' +
          '<div class="ml-qa__body"></div>' +
          '<div class="ml-qa__foot">' +
            '<button type="button" class="ml-ord__add ml-qa__add"></button>' +
            '<p class="ml-ord__note ml-qa__note"></p>' +
            '<a class="ml-qa__link" href="#">View full product details <span aria-hidden="true">&rarr;</span></a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(d);

    d.querySelector('.ml-qa__close').addEventListener('click', function () { closeDialog(); });
    /* Click on the backdrop, which is the dialog element itself outside the panel. */
    d.addEventListener('click', function (e) {
      if (e.target === d) { closeDialog(); return; }
      if (d._ddClose && !e.target.closest('.ml-qa__dd')) d._ddClose();
    });
    /* Escape closes an open color list first, and only then the dialog. */
    d.addEventListener('cancel', function (e) {
      if (d._ddIsOpen && d._ddIsOpen()) { e.preventDefault(); d._ddClose(); }
    });
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('ml-qa-open');
    });
    /* Small parallax on the stage: the picture and the big color word drift in
       opposite directions with the pointer. Skipped for reduced motion. */
    var stageEl = d.querySelector('.ml-qa__stage');
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && window.matchMedia('(hover: hover)').matches) {
      var raf = 0;
      stageEl.addEventListener('mousemove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = stageEl.getBoundingClientRect();
          stageEl.style.setProperty('--px', (((e.clientX - r.left) / r.width) * 2 - 1).toFixed(3));
          stageEl.style.setProperty('--py', (((e.clientY - r.top) / r.height) * 2 - 1).toFixed(3));
        });
      });
      stageEl.addEventListener('mouseleave', function () {
        stageEl.style.setProperty('--px', 0);
        stageEl.style.setProperty('--py', 0);
      });
    }
    QA = d;
    return d;
  }

  function closeDialog() {
    if (!QA) return;
    if (QA.open) QA.close();
    document.documentElement.classList.remove('ml-qa-open');
  }

  function openQuickAdd(info, url, imgSrc, priceText, displayTitle) {
    var d = ensureDialog();
    if (!d.showModal) { window.location.href = url; return; }

    var variants = info.v || [];
    var opts = optionsOf(variants);
    var colors = opts.colors;
    var sizes = opts.sizes;

    var stage = d.querySelector('.ml-qa__img');
    var stageBox = d.querySelector('.ml-qa__stage');
    var mark = d.querySelector('.ml-qa__mark');
    var count = d.querySelector('.ml-qa__count');
    var thumbs = d.querySelector('.ml-qa__thumbs');
    stage.alt = info.t || '';
    stage.removeAttribute('src');
    stageBox.style.removeProperty('--qa-bg');
    stageBox.style.removeProperty('--qa-mark');
    d._ddClose = null;
    d._ddIsOpen = null;
    d.querySelector('.ml-qa__facts').textContent = summaryFor(colors, sizes);
    d.querySelector('.ml-qa__title').textContent = displayTitle || info.t || '';
    d.querySelector('.ml-qa__price').textContent = priceText || '';
    d.querySelector('.ml-qa__link').setAttribute('href', url);

    var body = d.querySelector('.ml-qa__body');
    var addBtn = d.querySelector('.ml-qa__add');
    var note = d.querySelector('.ml-qa__note');
    body.innerHTML = '';
    thumbs.innerHTML = '';
    note.textContent = '';
    addBtn.className = 'ml-ord__add ml-qa__add';
    addBtn.disabled = false;

    var state = { color: null, size: null };
    for (var i = 0; i < variants.length; i++) {
      if (variants[i][3]) { state.color = variants[i][1] || null; break; }
    }
    if (!state.color && colors.length) state.color = colors[0];
    if (sizes.length === 1) state.size = sizes[0];

    function match(size) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (colors.length && v[1] !== state.color) continue;
        if (sizes.length && v[2] !== size) continue;
        return v;
      }
      return null;
    }

    function showImage() {
      var next = bigger((info.m && info.m[state.color]) || imgSrc) || '';
      if (stage.getAttribute('src') === next) return;
      stage.classList.add('is-loading');
      var done = function () { stage.classList.remove('is-loading'); };
      stage.onload = done;
      stage.onerror = done;
      setTimeout(done, 900);
      stage.src = next;
    }

    /* Colorway images sit under the main image. The color list on the right is
       a dropdown with a small picture beside each name. Both drive the same
       state, so picking in one moves the other. */
    function makeStep(label, labelId) {
      var w = document.createElement('section');
      w.className = 'ml-qa__step';
      w.innerHTML =
        '<div class="ml-qa__step-head">' +
          '<span class="ml-qa__step-n"><span class="ml-qa__step-num"></span>' +
          '<svg viewBox="0 0 20 20" width="12" height="12" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<span class="ml-qa__label"></span>' +
          '<span class="ml-qa__step-val"></span>' +
        '</div>' +
        '<div class="ml-qa__step-body"></div>';
      w.querySelector('.ml-qa__step-num').textContent = String(body.children.length + 1);
      var lab = w.querySelector('.ml-qa__label');
      lab.textContent = label;
      if (labelId) lab.id = labelId;
      body.appendChild(w);
      return { wrap: w, val: w.querySelector('.ml-qa__step-val'), content: w.querySelector('.ml-qa__step-body') };
    }
    var colorStep = null, sizeStep = null;

    /* Paint the stage: color word, counter and the tint sampled from the shirt. */
    function paintStage() {
      var word = state.color || '';
      mark.textContent = word;
      mark.className = 'ml-qa__mark';
      /* One line, sized to the whole name so two word colors never wrap or clip. */
      mark.style.whiteSpace = 'nowrap';
      mark.style.setProperty('--mfs', Math.max(8, Math.min(24, 94 / (Math.max(word.length, 1) * 0.66))).toFixed(1) + 'cqw');
      void mark.offsetWidth;
      mark.classList.add('is-in');
      var idx = colors.indexOf(state.color);
      count.textContent = colors.length > 1 && idx > -1
        ? (idx + 1 < 10 ? '0' : '') + (idx + 1) + ' / ' + (colors.length < 10 ? '0' : '') + colors.length
        : '';
      var src = bigger((info.m && info.m[state.color]) || imgSrc);
      var want = state.color;
      tintFor(src, function (t) {
        if (want !== state.color) return;
        if (t) { stageBox.style.setProperty('--qa-bg', t.bg); stageBox.style.setProperty('--qa-mark', t.mark); }
        else { stageBox.style.removeProperty('--qa-bg'); stageBox.style.removeProperty('--qa-mark'); }
      });
    }

    var thumbBtns = [];
    var ddBtn = null, ddList = null, ddName = null, ddThumb = null, ddOptions = [];

    function pickColor(name) {
      state.color = name;
      state.size = sizes.length === 1 ? sizes[0] : null;
      render();
    }

    if (colors.length > 1) {
      colorStep = makeStep('Color', 'ml-qa-color-label');

      var dd = document.createElement('div');
      dd.className = 'ml-qa__dd';

      ddBtn = document.createElement('button');
      ddBtn.type = 'button';
      ddBtn.className = 'ml-qa__dd-btn';
      ddBtn.setAttribute('aria-haspopup', 'listbox');
      ddBtn.setAttribute('aria-expanded', 'false');
      ddBtn.setAttribute('aria-labelledby', 'ml-qa-color-label ml-qa-color-value');
      ddBtn.innerHTML =
        '<span class="ml-qa__dd-thumb"><img alt=""></span>' +
        '<span class="ml-qa__dd-name" id="ml-qa-color-value"></span>' +
        '<svg class="ml-qa__dd-chev" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M5 7.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      ddName = ddBtn.querySelector('.ml-qa__dd-name');
      ddThumb = ddBtn.querySelector('.ml-qa__dd-thumb');

      ddList = document.createElement('ul');
      ddList.className = 'ml-qa__dd-list';
      ddList.setAttribute('role', 'listbox');
      ddList.setAttribute('aria-labelledby', 'ml-qa-color-label');
      ddList.tabIndex = -1;
      ddList.hidden = true;

      dd.appendChild(ddBtn);
      dd.appendChild(ddList);
      colorStep.content.appendChild(dd);

      var openList = function () {
        if (!ddList.hidden) return;
        ddList.hidden = false;
        ddBtn.setAttribute('aria-expanded', 'true');
        dd.classList.add('is-open');
        var cur = ddOptions.filter(function (o) { return o.dataset.color === state.color; })[0] || ddOptions[0];
        if (cur) { cur.focus(); cur.scrollIntoView({ block: 'nearest' }); }
      };
      var closeList = function (refocus) {
        if (ddList.hidden) return;
        ddList.hidden = true;
        ddBtn.setAttribute('aria-expanded', 'false');
        dd.classList.remove('is-open');
        if (refocus) ddBtn.focus();
      };
      d._ddClose = function () { closeList(true); };
      d._ddIsOpen = function () { return !ddList.hidden; };

      ddBtn.addEventListener('click', function () { ddList.hidden ? openList() : closeList(true); });
      ddBtn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openList(); }
      });

      colors.forEach(function (name) {
        var li = document.createElement('li');
        li.className = 'ml-qa__dd-opt';
        li.setAttribute('role', 'option');
        li.tabIndex = -1;
        li.dataset.color = name;
        var img = info.m && info.m[name];
        li.innerHTML =
          '<span class="ml-qa__dd-thumb">' + (img ? '<img alt="" loading="lazy">' : '') + '</span>' +
          '<span class="ml-qa__dd-label"></span>' +
          '<svg class="ml-qa__dd-tick" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M4.5 10.5l3.5 3.5 7.5-8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        li.querySelector('.ml-qa__dd-label').textContent = name;
        if (img) li.querySelector('img').src = img;
        li.addEventListener('click', function () { pickColor(name); closeList(true); });
        li.addEventListener('keydown', function (e) {
          var i = ddOptions.indexOf(li);
          if (e.key === 'ArrowDown') { e.preventDefault(); (ddOptions[i + 1] || ddOptions[0]).focus(); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); (ddOptions[i - 1] || ddOptions[ddOptions.length - 1]).focus(); }
          else if (e.key === 'Home') { e.preventDefault(); ddOptions[0].focus(); }
          else if (e.key === 'End') { e.preventDefault(); ddOptions[ddOptions.length - 1].focus(); }
          else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pickColor(name); closeList(true); }
          else if (e.key === 'Tab') { closeList(false); }
        });
        ddList.appendChild(li);
        ddOptions.push(li);
      });

      colors.forEach(function (name) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ml-qa__swatch';
        b.setAttribute('aria-label', name);
        b.setAttribute('title', name);
        b.dataset.color = name;
        var img = info.m && info.m[name];
        if (img) {
          var im = document.createElement('img');
          im.src = img;
          im.alt = '';
          im.loading = 'lazy';
          b.appendChild(im);
        } else {
          b.classList.add('ml-qa__swatch--text');
          b.textContent = name;
        }
        b.addEventListener('click', function () { pickColor(name); });
        thumbs.appendChild(b);
        thumbBtns.push(b);
      });
    }
    thumbs.hidden = thumbBtns.length === 0;

    var sizeRow = null;
    if (sizes.length > 1) {
      sizeStep = makeStep('Size', 'ml-qa-size-label');
      sizeRow = document.createElement('div');
      sizeRow.className = 'ml-ord__sizes';
      sizeStep.content.appendChild(sizeRow);
    }

    function render() {
      thumbBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.color === state.color));
      });
      if (ddBtn) {
        ddName.textContent = state.color || '';
        var cimg = info.m && info.m[state.color];
        var timg = ddThumb.querySelector('img');
        ddThumb.classList.toggle('is-empty', !cimg);
        if (timg) { if (cimg) timg.src = cimg; else timg.removeAttribute('src'); }
        ddOptions.forEach(function (o) {
          o.setAttribute('aria-selected', String(o.dataset.color === state.color));
        });
      }
      paintStage();
      showImage();

      if (sizeRow) {
        sizeRow.innerHTML = '';
        sizes.forEach(function (size) {
          var v = match(size);
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ml-ord__size';
          b.textContent = size;
          if (!v || !v[3]) {
            b.disabled = true;
            b.setAttribute('aria-label', size + ', sold out');
          } else {
            b.setAttribute('aria-pressed', String(size === state.size));
            b.addEventListener('click', function () { state.size = size; render(); });
          }
          sizeRow.appendChild(b);
        });
      }

      if (colorStep) { colorStep.val.textContent = state.color || ''; colorStep.wrap.classList.add('is-done'); }
      if (sizeStep) {
        sizeStep.val.textContent = state.size || '';
        sizeStep.wrap.classList.toggle('is-done', !!state.size);
      }

      var chosen = match(state.size);
      if (sizes.length > 1 && !state.size) {
        addBtn.disabled = true;
        addBtn.textContent = 'Choose a size to add';
      } else if (!chosen || !chosen[3]) {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold out';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to cart';
      }
    }

    addBtn.onclick = function () {
      var chosen = match(state.size);
      if (!chosen || !chosen[3]) return;
      addToCart(chosen[0], addBtn, note, 'Add to cart', closeDialog);
    };

    render();
    document.documentElement.classList.add('ml-qa-open');
    d.showModal();
    var first = body.querySelector('.ml-ord__size:not([disabled])') || ddBtn || addBtn;
    if (first) first.focus({ preventScroll: true });
  }

  E.openQuickAdd = openQuickAdd;
})();
